import { TableGridContext } from "components/Table";
import { ITableGridContext } from "Interfaces/Components/TableGrid";
import { useContext } from "react";

export default function useTable(): ITableGridContext {
  const context = useContext(TableGridContext);

  return context;
}
